import React, { Component, Fragment } from "react";
import config from "../../../../config/config.json";
import { newsLetterSubscription } from "../../../../shared/lib/newsSubscription";
import { emailValidation } from "../../../../common/lib/utils/regex_cheat_sheet";

class Footer11 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      error: '',
      success: '' // Add this line
    };

    // store timeout id so we can clear it on unmount / before creating a new one
    this.successTimeout = null;

  }

  // Extract site_id and accessToken just like in NewsLetterSubscription
  getSiteId() {
    // Reference: props?.pageInfo?.site?.id in NewsLetterSubscription
    return this.props?.pageInfo?.site?.id;
  }

  getAccessToken() {
    // Reference: ctx.user.accessToken in NewsLetterSubscription
    return this.props?.userToken;
  }

  // Example: Use these in a subscribe handler
  handleSubscribe = () => {
    const { email } = this.state;
    const site_id = this.getSiteId();
    const accessToken = this.getAccessToken();

    if ((email.trim() !== email || email.includes(' '))) {

      this.setState({ error: 'No spaces allowed in email', success: '' });
      return;
    }

    if (!email) {
      this.setState({ error: 'Email address is required.', success: '' });
      return;
    }

    if (email.length > 254) {
      this.setState({ error: 'Maximum allowed length is 254 characters.', success: '' });
      return;
    }
    if (!emailValidation.test(email)) {
      this.setState({ error: 'Please enter a valid email address.', success: '' });
      return;
    }

    const data = { accessToken, email, site_id };

    newsLetterSubscription(data)
      .then((res) => {
        if (res?.data?.status) {
          // clear any existing timeout before setting a new one
          if (this.successTimeout) {
            clearTimeout(this.successTimeout);
            this.successTimeout = null;
          }
          this.setState({ email: '', error: '', success: 'Thank you for subscribing.' }, () => {
            // remove success message after 3 seconds
            this.successTimeout = setTimeout(() => {
              this.setState({ success: '' });
              this.successTimeout = null;
            }, 3000);
          });
        } else if (res?.data?.error?.details) {
          this.setState({ error: res?.data?.error?.details, success: '' });
        } else {
          this.setState({ error: 'Subscription failed. Please try again.', success: '' });
        }
      })
      .catch(() => {
        this.setState({ error: 'Subscription failed. Please try again.' });
      });
  };




  render() {
    const styles = this.props.data.cssfile;
    const accessToken = this.props?.data?.siteData?.data?.access_token || '';
    const socialMedia =
      this?.props?.data?.siteData?.data?.footer?.socialmedia || [];
    return (
      <>
        {!this?.props?.data?.isMobile && (
          <footer className={`${this.props.data.cssfile.footer} ${this.props?.data?.siteData?.data?.user?.rg_type === "vendor" && this.props.data.cssfile.subscription_footer}`}>
            {/* Footer Top Section */}
            <div className={this.props.data.cssfile.footer__top}>
              <div
                className={`${this.props.data.cssfile.footer__top_container} ${this.props.data.cssfile.tour__container}`}
              >
                {/* Logo */}
                {this.props?.data?.siteData?.data?.user?.rg_type === "vendor" ? (
                  <div className={this.props.data.cssfile.footer__logo}>
                    <div className={this.props.data.cssfile.footer_logo}>
                      <img
                        src={`${"/shared/api/media/" +
                          this.props?.data?.siteData?.site.id +
                          "/" +
                          this.props?.data?.footermenu?.logo
                          }`}
                        alt="Logo"
                      />
                    </div>
                  </div>
                ) : (
                  <a href="/" >
                    <div className={this.props.data.cssfile.footer__logo}>
                      <div className={this.props.data.cssfile.footer_logo}>
                        <img
                          src={`${"/shared/api/media/" +
                            this.props?.data?.siteData?.site.id +
                            "/" +
                            this.props?.data?.footermenu?.logo
                            }`}
                          alt="Logo"
                        />
                      </div>
                    </div>
                  </a>
                )}
                {/* Contact Information */}
                <div className={this.props.data.cssfile.footer__contact}>
                  {/* Connect with us */}
                  <div className={this.props.data.cssfile.contact_section}>
                    <h3
                      className={this.props.data.cssfile.contact_section__title}
                    >
                      Connect with us
                    </h3>
                    <div className={this.props.data.cssfile.social_icons}>
                      <div
                        className={
                          this.props.data.cssfile.social_icons__itemFlex
                        }
                      >
                        {socialMedia.map((item, idx) => (
                          <a
                            key={idx}
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={
                              this.props.data.cssfile.social_icons__item
                            }
                          >
                            <img
                              src={`${"/shared/api/media/" +
                                this.props?.data?.siteData?.site.id +
                                "/" +
                                `${item.icon}`
                                }`}
                              // src={item.icon ? `/images/${item.icon}` : ''}
                              alt={item.text}
                            />
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>
                  {/* Call Us */}
                  <div className={this.props.data.cssfile.contact_section}>
                    <h3
                      className={this.props.data.cssfile.contact_section__title}
                    >
                      Call Us
                    </h3>
                    <div className={this.props.data.cssfile.contact_info}>
                      <img
                        src="/images/call_icon.svg"
                        alt="Phone"
                        className={this.props.data.cssfile.contact_info__icon}
                      />
                      <span
                        className={this.props.data.cssfile.contact_info__text}
                      >
                        <a
                          href={`tel:${this.props?.data?.siteData?.site?.support_number}`}
                          className={this.props.data.cssfile.contact_info__text}
                        >
                          {this.props?.data?.siteData?.site?.support_number}
                        </a>
                      </span>
                    </div>
                  </div>
                  {/* Write to Us */}
                  <div className={this.props.data.cssfile.contact_section}>
                    <h3
                      className={this.props.data.cssfile.contact_section__title}
                    >
                      Write to Us
                    </h3>
                    <div className={this.props.data.cssfile.contact_info}>
                      <img
                        src="/images/mail_icon.svg"
                        alt="Email"
                        className={this.props.data.cssfile.contact_info__icon}
                      />
                      <span
                        className={this.props.data.cssfile.contact_info__text}
                      >
                        <a
                          href={`mailto:${this.props?.data?.siteData?.site?.support_email}`}
                        >
                          {this.props?.data?.siteData?.site?.support_email}
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Footer Main Section */}
            <div className={this.props.data.cssfile.footer__main}>
              <div
                className={`${this.props.data.cssfile.footer__main_container} ${this.props.data.cssfile.tour__container}`}
              >
                <div className={this.props.data.cssfile.footer__content}>
                  {this.props?.data?.siteData?.data?.user?.rg_type !== "vendor" && (
                    <>
                      {/* Newsletter Section */}
                      <div className={this.props.data.cssfile.newsletter}>
                        <h3 className={this.props.data.cssfile.newsletter__title}>
                          Subscribe today for exclusive news, & updates.
                        </h3>
                        <div className={this.props.data.cssfile.newsletter__form}>
                          <input
                            type="text"
                            placeholder="Enter your email id"
                            className={this.props.data.cssfile.newsletter__input}
                            value={this.state.email}
                            onChange={(e) => {
                              let email = e.target.value;
                              // Remove leading and trailing spaces as user types
                              email = email.replace(/^\s+|\s+$/g, "");
                              this.setState({ email, success: '', error: '' });
                            }}
                          />
                          <button
                            type="submit"
                            className={this.props.data.cssfile.newsletter__button}
                            onClick={this.handleSubscribe}
                          >
                            Subscribe
                          </button>
                        </div>
                        {this.state.error && (
                          <div className={this.props.data.cssfile.error_message}>
                            {this.state.error}
                          </div>
                        )}
                        {this.state.success && (
                          <div className={this.props.data.cssfile.success_message}>
                            {this.state.success}
                          </div>
                        )}
                      </div>
                      {/* Footer Links */}
                      <div className={this.props.data.cssfile.footer__links}>
                        <div className={this.props.data.cssfile.footer__column}>
                          <a
                            href="/holiday/destination"
                            className={this.props.data.cssfile.footer__link}
                          >
                            Destinations
                          </a>
                          <a
                            href="/tourpackages"
                            className={this.props.data.cssfile.footer__link}
                          >
                            Holidays
                          </a>
                          <a
                            href="/holiday/tourmaster"
                            className={this.props.data.cssfile.footer__link}
                          >
                            Tour Masters
                          </a>

                        </div>
                        <div className={this.props.data.cssfile.footer__column}>
                          {!accessToken && (<>
                            <a
                              href="/registration"
                              className={this.props.data.cssfile.footer__link}
                            >
                              Become a Tour Master
                            </a>
                            <a
                              href="/vendor"
                              className={this.props.data.cssfile.footer__link}
                            >
                              Become a Vendor
                            </a>
                          </>
                          )}
                          <a
                            href="/about-us"
                            className={this.props.data.cssfile.footer__link}
                          >
                            About tripbutter
                          </a>
                          {/* <a
                        href="#"
                        className={this.props.data.cssfile.footer__link}
                      >
                        Offers
                      </a> */}
                        </div>
                        <div className={this.props.data.cssfile.footer__column}>

                          <a
                            href="/fnq"
                            className={this.props.data.cssfile.footer__link}
                          >
                            FAQs
                          </a>
                          <a
                            href="/contact-us"
                            className={this.props.data.cssfile.footer__link}
                          >
                            Contact Us
                          </a>
                          <a
                            href="/holiday/testimonials"
                            className={this.props.data.cssfile.footer__link}
                          >
                            Testimonials
                          </a>
                        </div>
                        <div className={this.props.data.cssfile.footer__column}>

                          {/* <a
                            href="/holiday/travelarticle"
                            className={`${this.props.data.cssfile.footer__link} ${this.props.data.cssfile.footer__hide}`}
                          >
                            Travel Articles
                          </a> */}
                          <a
                            href="/career"
                            className={this.props.data.cssfile.footer__link}
                          >
                            Careers
                          </a>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {/* Footer Bottom */}
                <div className={this.props.data.cssfile.footer__bottom}>
                  <div className={this.props.data.cssfile.footer__copyright}>
                    <span> {this.props?.data?.footermenu?.text}</span>
                  </div>

                  {this.props?.data?.siteData?.data?.user?.rg_type !== "vendor" && (
                    <div className={this.props.data.cssfile.footer__legal}>
                      <a
                        href="/terms-and-conditions"
                        className={this.props.data.cssfile.footer__legal_link}
                      >
                        Terms & Conditions
                      </a>
                      <span className={this.props.data.cssfile.footer__separator}>
                        |
                      </span>
                      <a
                        href="/privacy-policy"
                        className={this.props.data.cssfile.footer__legal_link}
                      >
                        Privacy Policy
                      </a>
                      <span className={this.props.data.cssfile.footer__separator}>
                        |
                      </span>
                      <a
                        href="/disclaimer"
                        className={this.props.data.cssfile.footer__legal_link}
                      >
                        Disclaimer
                      </a>
                    </div>
                  )}
                  <div className={this.props.data.cssfile.footer__powered}>
                    <span>Powered by </span>
                    <div
                      className={
                        this.props.data.cssfile.footer__powered_mainLogo
                      }
                    >
                      <a href="https://www.vernost.com/" target="_blank">
                        <img
                          src="/images/vernost_logo.svg"
                          alt="Powered by"
                          className={
                            this.props.data.cssfile.footer__powered_logo
                          }
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        )}
      </>
    );
  }
}

export default Footer11;
